import React, {FC} from 'react'
import i18n from "../../i18n";
import style from "./Error404.module.css";
import {useTranslation} from "react-i18next";
import {IoArrowBack, IoArrowForward} from "react-icons/io5";
import {getLang, getUrlBasedOnCountry} from "../../Helpers/functions";

const Error404: FC = () => {
    const {t} = useTranslation()

    const getIcon = (key: string) => {
        return require(`../../Assets/Images/OpenSooq/${key}.png`)
    }

    return (
        <div dir={i18n.language=='en'?'ltr':'rtl'} className={style.container}
             style={{display: "flex", flexDirection: "column", justifyContent: "start", alignItems: "center"}}>
                <img style={{maxWidth:"100%",objectFit:"cover",height:"50%"}}
                    src={getIcon("opensooq-bg-image")}></img>
            <br/>
            <div className={style.row}>
                <h1 className={`${style.no_pad} ${style.bold}`}>{t('somethingWentWrong')}</h1>
            </div>
            <div className={style.row}>
                <p style={{textAlign: "center"}} className={`${style.font_size_sm} mb-0`}>{t('apologise')}</p>
            </div>
            <div className={style.row}>
                <p style={{textAlign: "center"}}
                   className={`${style.font_size_sm} mb-0`}>{t('workingToFixProblem')}</p>
            </div>
            <div className={`row mt-2`} style={{padding: "10px", width: "100%"}}>
                <div className={`col-11`} style={{display:"flex",justifyContent:"center",alignItems:"center",width:"100%"}}>
                    <button onClick={()=>{
                        window.location.href = getUrlBasedOnCountry(localStorage.getItem('countryCode') ?? 'jo', getLang());
                    }} className={`${style.error_btn}`}>
                        <div className={`row`}>
                            <div className={`col-12`}>
                                <div style={{
                                    display: "inline-block",
                                    marginTop: "5px"
                                }}>                                 {t('back')}
                                </div>
                                <span className={`${i18n.language=='en'?`float-end`:'float-start'}`}><div
                                    className={`${style.iconContainer}`}>{i18n.language=='en'?<IoArrowForward/>:<IoArrowBack/>} </div></span>
                            </div>

                        </div>

                    </button>

                </div>
            </div>
            <p className={`mt-3`}
               style={{display: "flex", justifyContent: "center", alignItems: "center",fontSize:"16px"}}> {t('doYouNeedHelp')} <a
                target={"_top"}
                href={`https://jo.opensooq.com/${i18n.language}/support`}
                className={`${style.hyperlink}`}>{t('contactUs')} </a>
            </p>

        </div>
    )
}

export {Error404}
